<template>
	<view>
		<view class="login" v-if="isPhone">
			<view class="tab">
				<view class="item" v-for="(item,index) in tabList" :key="index"
					:class="tabIndex===index ? 'active' : ''" @click="handleLoginTab(index)">{{item}}</view>
			</view>
			<view class="phone">
				<view class="phone_icon"></view>
				<input class="uni-input" type="number" :placeholder="tabIndex == 0 ? '请输入手机号' : '请输入用户账号'"
					v-model="phone" />
			</view>
			<!--验证码登录-->
			<view class="verify" v-if="tabIndex == 0">
				<view class="verify_l">
					<view class="verify_icon"></view>
					<input class="uni-input" type="number" placeholder="请输入验证码" v-model="verifyCode" />
				</view>
				<button type="default" @click="getVerify" class="btn">{{msg}}</button>
			</view>
			<!--密码登录-->
			<view class="password" v-else>
				<view class="password_icon"></view>
				<input class="uni-input" password type="text" placeholder="请输入密码" v-model="passwordCode" />
			</view>
			<button type="default" @click="handleLoginFn()" class="btnLogin">登录</button>
			<view class="lostPassword" v-if="tabIndex == 1" @click="handleLostPassword()">忘记密码</view>
			<checkbox-group class="uni-list" @change="checkboxChange">
				<label class="label">
					<view class="uni-list-cell uni-list-cell-pd">
						<checkbox class="checkbox" :checked="isChecked">我已阅读并同意<view class="protocol color"
								@click="handleProtocal()">《用户协议》
							</view>和<view class="privacy color" @click="handlePrivacy()">《隐私政策》</view>
						</checkbox>
					</view>
				</label>
			</checkbox-group>
			<view class="desc">
				<view class="desc_icon"></view>
				<view class="notice">若该手机号未注册，我们将自动为您注册</view>
			</view>
		</view>
		<view class="login2023" v-else>
			<view class="code2023">
				<view class="code-tip-one">
					<view class="name">请输入验证码</view>
					<view class="code-tip">验证码已发送至
						{{phone.substring(0, 3)}}****{{phone.substr(phone.length-4)}}
					</view>
				</view>
				<div class="codeDiv">
					<input class="code uni-input" :focus="focus1" @input="onKeyInput1" type="number" maxlength='1'
						v-model="inp1" />
					<input class="code uni-input" :focus="focus2" @input="onKeyInput2" type="number" maxlength='1'
						v-model="inp2" />
					<input class="code uni-input" :focus="focus3" @input="onKeyInput3" type="number" maxlength='1'
						v-model="inp3" />
					<input class="code uni-input" :focus="focus4" @input="onKeyInput4" type="number" maxlength='1'
						v-model="inp4" />
					<input class="code uni-input" :focus="focus5" @input="onKeyInput5" type="number" maxlength='1'
						v-model="inp5" />
					<input class="code uni-input" :focus="focus6" @input="onKeyInput6" type="number" maxlength='1'
						v-model="inp6" />
				</div>
				<block>
					<view class="recode" v-if="sec > 0">{{sec}}秒后可重新发送</view>
					<view class="reagain" v-else @click="handleAgain()">点击重新发送验证码</view>
				</block>
				<button type="button" class="btn" @click="handleSubmit()">提交</button>
			</view>
		</view>
	</view>
</template>

<script>
	import md5 from 'js-md5';

	export default {
		data() {
			return {
				tabList: ['验证码登录', '账号密码登录'],
				tabIndex: 0,
				isChecked: false,
				userKey: null, //安全码
				phone: '', //手机号
				verifyCode: '', //验证码
				access_token: '', //用户token,
				passwordCode: '', //密码
				userId: '', //用户id
				number: 60,
				msg: '获取验证码',
				countTimer: null,

				isPhone: true, //判断手机号是否存在
				timer: null,
				sec: 60, //这是重新获取验证码的倒计时
				focus1: true,
				focus2: false,
				focus3: false,
				focus4: false,
				focus5: false,
				focus6: false,
				inp1: '',
				inp2: '',
				inp3: '',
				inp4: '',
				inp5: '',
				inp6: '',
				isStatus: null, //是否有手机号的状态码
			}
		},
		beforeMount() {
			// console.log(this.$store.state.phone)
		},
		//监听页面销毁
		onHide() {
			this.countTimer && clearInterval(this.countTimer);
			this.timer && clearInterval(this.timer);
		},
		methods: {
			//登录方式切换
			handleLoginTab(index) {
				this.tabIndex = index;
				this.phone = '';
				this.verifyCode = '';
			},
			//获取验证码
			getVerify() {
				let reg = /^((13[0-9])|(14[0-9])|(15[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
				if (reg.test(this.phone)) {
					this.getSafetyCode(); //获取安全码
				} else {
					this.showTips('请输入正确的手机号！');
					this.phone = '';
				}

			},
			//气泡提示
			showTips(title) {
				uni.showToast({
					icon: 'none',
					title: title,
					// duration: 2000
				})
			},
			//登录
			handleLoginFn() {
				let reg = /^((13[0-9])|(14[0-9])|(15[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;

				if (this.tabIndex == 0) {
					if (reg.test(this.phone)) {
						if (this.verifyCode == '') {
							this.showTips('请输入正确的验证码！');
						} else {
							if (this.isChecked == false) {
								this.showTips('请勾选同意后再登录！');
							} else {
								this.loginFn(); //登录接口
							}
						}
					} else {
						this.showTips('请输入正确的手机号！');
						this.phone = '';
						this.verifyCode = '';
					}
				} else {
					if (reg.test(this.phone)) {
						if (this.passwordCode == '') {
							this.showTips('请输入正确的密码！');
						} else {
							if (this.isChecked == false) {
								this.showTips('请勾选同意后再登录！');
							} else {
								// this.loginFn(); //登录接口
								this.isHasPhone(); //验证手机号是否存在
							}
						}
					} else {
						this.showTips('请输入正确的手机号！');
						this.phone = '';
						this.passwordCode = '';
					}
				}

			},
			//checkbox切换选择
			checkboxChange: function(e) {
				this.isChecked = !this.isChecked;
			},
			//用户协议
			handleProtocal() {
				window.open('https://rjdiandu.mypep.cn/4.2/h5/protocol', '_blank');
			},
			//隐私政策
			handlePrivacy() {
				window.open('https://rjdiandu.mypep.cn/h5/privacy', '_blank');
			},
			//忘记密码
			handleLostPassword() {
				uni.navigateTo({
					url: '/pages/login/mpwdpage/index'
				});
			},
			//获取安全码
			getSafetyCode() {
				let dev_pro = process.env.NODE_ENV; //获取环境变量
				let url;
				if (dev_pro == 'development') {
					url = this.baseApi + '/user/user_key.anys';
				} else {
					url = this.baseURL + '/user/user_key.anys';
				}
				uni.request({
					url: url,
					method: 'post',
					data: {},
					header: {
						"Content-Type": "application/x-www-form-urlencoded",
						"version": this.version,
						"app-channel": this.app_channel
					},
					success: res => {
						// console.log(res, '安全码');
						if (res.data.errcode == '110') {
							this.userKey = res.data.user_key;
							this.getVerifyCode(); //获取验证码
						}
					},
					fail: err => {
						console.log(err);
					}
				})
			},
			//获取验证码
			getVerifyCode() {
				let dev_pro = process.env.NODE_ENV; //获取环境变量
				let url;
				if (dev_pro == 'development') {
					url = this.baseApi + '/user/login/sendcaptcha.anys';
				} else {
					url = this.baseURL + '/user/login/sendcaptcha.anys';
				}
				uni.request({
					url: url,
					method: 'post',
					data: {
						user_key: this.userKey,
						username: encodeURI('JszX/Dd+' + this.Rsa.encrypt(this.phone))
					},
					header: {
						"Content-Type": "application/x-www-form-urlencoded",
						"version": this.version,
						"app-channel": this.app_channel
					},
					success: res => {
						// console.log(res, '短信验证码');
						if (res.data.errcode == '110') {
							this.showTips('验证码发送成功！');
							this.countDown(); //倒计时
						} else {
							this.showTips(res.data.errmsg);
						}
					},
					fail: err => {
						console.log(err);
					}
				})
			},
			//登录接口
			loginFn() {
				let dev_pro = process.env.NODE_ENV; //获取环境变量
				let url;
				if (dev_pro == 'development') {
					url = this.baseApi + '/user/ak/pep_click/login.anys';
				} else {
					url = this.baseURL + '/user/ak/pep_click/login.anys';
				}
				let objParams;
				if (this.tabIndex == 0) {
					if (this.isStatus == '1329') {
						objParams = {
							username: encodeURI('JszX/Dd+' + this.Rsa.encrypt(this.phone)),
							captcha: encodeURI('JszX/Dd+' + this.Rsa.encrypt(this.verifyCode)),
							channel_id: 'web',
							dev_id: 'pc',
							dev_name: 'pc',
							pwd: encodeURI('JszX/Dd+' + this.Rsa.encrypt(this.passwordCode))
						}
					} else {
						objParams = {
							username: encodeURI('JszX/Dd+' + this.Rsa.encrypt(this.phone)),
							captcha: encodeURI('JszX/Dd+' + this.Rsa.encrypt(this.verifyCode)),
							channel_id: 'web',
							dev_id: 'pc',
							dev_name: 'pc',
						}
					}
				} else {
					objParams = {
						username: encodeURI('JszX/Dd+' + this.Rsa.encrypt(this.phone)),
						pwd: encodeURI('JszX/Dd+' + this.Rsa.encrypt(this.passwordCode)),
						channel_id: 'web',
						dev_id: 'pc',
						dev_name: 'pc'
					}
				}
				uni.request({
					url: url,
					method: 'post',
					data: objParams,
					header: {
						"Content-Type": "application/x-www-form-urlencoded",
						"version": this.version,
						"app-channel": this.app_channel
					},
					success: res => {
						// console.log(res, '登录信息');
						if (res.data.errcode == '110') {
							this.showTips('登录成功！');
							this.access_token = res.data.access_token;
							this.$store.commit('setToken', this.access_token);
							this.$store.commit('setPhone', this.phone);
							this.userId = res.data.user_info.user_id;
							this.$store.commit('setUserId', this.userId);

							//存用户id(用于大数据埋点)
							localStorage.setItem('activeUserId', this.userId);

							//存用户id(用于防篡改用户)
							let userIdStr = md5(this.userId + 'rjdd_web');
							localStorage.setItem('userIdStr', userIdStr);

							let hash = window.location.hash;

							//登录页
							if (hash.includes('loginpage')) {
								
								uni.navigateTo({
									// url: '/pages/userInfo/myOrder/index?userId=' + this.userId
									url: '/pages/userInfo/myOrder/index'
								});
							} else if (hash.includes('myStudy')) { //我的学习
								window.location.reload();

								this.$emit('handleClickStudy_son');
								this.$emit('hasPurchased_son'); //获取用户已购买的书籍
							} else { //首页
								window.location.reload();

								this.$emit('handleClickLogin_son', '登录');
								this.$emit('judgeBuyFn_son'); //获取用户已购买的书籍
							}

							clearInterval(this.countTimer);
							clearInterval(this.timer);

						} else {
							this.showTips(res.data.errmsg);
						}
					},
					fail: err => {
						console.log(err);
					}
				})
			},
			//倒计时
			countDown() {
				let _this = this;
				_this.countTimer = setInterval(function() {
					// console.log(_this.number);
					_this.number--;
					_this.msg = _this.number + '秒';
					if (_this.number < 0) {
						clearInterval(_this.countTimer);
						_this.number = 60;
						_this.msg = '获取验证码';
						return false;
					}
				}, 1000)
			},

			//验证手机号是否存在
			isHasPhone() {
				let dev_pro = process.env.NODE_ENV; //获取环境变量
				let url;
				if (dev_pro == 'development') {
					url = this.baseApi + '/user/' + this.phone + '/mobile_unique.anys?access_token=';
				} else {
					url = this.baseURL + '/user/' + this.phone + '/mobile_unique.anys?access_token=';
				}
				uni.request({
					url: url,
					method: 'post',
					data: {},
					header: {
						"Content-Type": "application/x-www-form-urlencoded",
						"version": this.version,
						"app-channel": this.app_channel
					},
					success: res => {
						// console.log(res, '判断手机号是否存在');
						let resCode = res.data.errcode;
						if (res.statusCode == '200') {
							if (resCode == '1328') { //手机号已存在
								this.isStatus = '1328';
								this.loginFn(); //登录接口
							} else if (resCode == '1329') { //手机号不存在
								this.isPhone = false;
								this.isStatus = '1329';
								this.getSafetyCode(); //获取安全码
								this.timedown(); //倒计时
							}
						}
					},
					fail: err => {
						console.log(err);
					}
				})
			},
			//倒计时
			timedown() {
				let _this = this;
				_this.timer = setInterval(function() {
					// console.log(_this.sec);
					_this.sec--;
					if (_this.sec < 0) {
						clearInterval(_this.timer);
						return false;
					}
				}, 1000)
			},
			//重新发送验证码
			handleAgain() {
				this.sec = 60,
					this.getSafetyCode(); //获取安全码
				this.timedown(); //倒计时
				this.inp1 = "";
				this.inp2 = "";
				this.inp3 = "";
				this.inp4 = "";
				this.inp5 = "";
				this.inp6 = "";
			},
			//点击提交
			handleSubmit() {
				this.verifyCode = this.inp1 + this.inp2 + this.inp3 + this.inp4 + this.inp5 + this.inp6;

				this.inp1 = "";
				this.inp2 = "";
				this.inp3 = "";
				this.inp4 = "";
				this.inp5 = "";
				this.inp6 = "";

				this.tabIndex = 0;
				this.loginFn(); //登录接口
			},
			//自动聚焦
			onKeyInput1: function(e) {
				let value = e.detail.value;
				if (value != "") {
					this.focus2 = true;
				}
			},
			onKeyInput2: function(e) {
				let value = e.detail.value;
				if (value != "") {
					this.focus3 = true;
				}
			},
			onKeyInput3: function(e) {
				let value = e.detail.value;
				if (value != "") {
					this.focus4 = true;
				}
			},
			onKeyInput4: function(e) {
				let value = e.detail.value;
				if (value != "") {
					this.focus5 = true;
				}
			},
			onKeyInput5: function(e) {
				let value = e.detail.value;
				if (value != "") {
					this.focus6 = true;
				}
			},
			onKeyInput6: function(e) {
				let value = e.detail.value;
				if (value != "") {
					this.focus6 = false;
				}
			},

		}
	}
</script>

<style lang="scss" scoped scoped>
	@import "@/style/components/login.scss"; //引入样式文件
</style>
